import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  menuPopoverPositioned: {
    animationName: "none !important" as any,
    "&[data-popper-placement]": {
      visibility: "visible !important" as any,
      opacity: "1 !important" as any,
      animationName: "none !important" as any,
    },
  },
});
